import React, { useContext } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Icon, ScrollView } from '../components/ui';
import { Loading } from '../components/utils';
import { AccountContext } from '../context/account';
import { NotebookContext } from '../context/NotebookContext';
import redirect from '../lib/redirect';
import {
  CreateNotebookMutation,
  CreateNotebookMutationVariables
} from '../queries/__generated__/CreateNotebookMutation';
import { NotebooksQueryVariables } from '../queries/__generated__/NotebooksQuery';
import {
  NotebookTemplatesQuery,
  NotebookTemplatesQuery_notebookTemplates
} from '../queries/__generated__/NotebookTemplatesQuery';
import {
  createNotebookMutation,
  notebooksQuery,
  notebookTemplatesQuery
} from '../queries/notebooks';
import { back } from '../lib/helpers/navigate';

interface INotebookTemplate {
  template: NotebookTemplatesQuery_notebookTemplates;
}

const NotebookTemplate: React.FC<INotebookTemplate> = ({ template }) => {
  const accountContext = useContext(AccountContext);

  const handleCreateNotebook = async (createNotebook: any) => {
    const response = await createNotebook();
    const newNotebookId = response.data.createNotebook.notebook.id;

    localStorage.setItem('selectedNotebookId', newNotebookId);
    redirect('/notebook');
  };

  return (
    <li key={template.id} className="mb3" data-testid="template">
      <Mutation<CreateNotebookMutation, CreateNotebookMutationVariables>
        mutation={createNotebookMutation}
        variables={{
          input: {
            name: template.name,
            templateId: template.id,
            accountId: accountContext.selectedAccountId
          }
        }}
        refetchQueries={[
          {
            query: notebooksQuery,
            variables: {
              input: {
                accountId: accountContext.selectedAccountId
              }
            } as NotebooksQueryVariables
          }
        ]}
      >
        {(createNotebook, { error }) => (
          <button
            type="button"
            className="display f3 f2-ns"
            data-testid={`create-notebook-${template.id}`}
            onClick={() => handleCreateNotebook(createNotebook)}
          >
            {error ? error.message : template.name}
          </button>
        )}
      </Mutation>
    </li>
  );
};

const NotebookTemplatesPage: React.FC = () => {
  return (
    <>
      <div className="pa3">
        <button type="button" onClick={() => back()}>
          <Icon name="close" />
        </button>
      </div>

      <ScrollView>
        <Query<NotebookTemplatesQuery> query={notebookTemplatesQuery}>
          {({ data, loading }) => {
            if (loading) {
              return <Loading />;
            }

            return (
              <div className="pa3 tc">
                <p className="f4 serif i tan lh-copy mb4">
                  Select a Notebook template to add to your notebook party
                </p>

                <ul className="list pa0">
                  {data!.notebookTemplates.map(notebookTemplate => (
                    <NotebookTemplate key={notebookTemplate!.id} template={notebookTemplate} />
                  ))}
                </ul>
              </div>
            );
          }}
        </Query>
      </ScrollView>
    </>
  );
};

export default NotebookTemplatesPage;
